/* eslint-disable no-console */

export function logInfo(message?: any, ...optionalParams: any[]) {
  console.log(message, ...optionalParams);
}

export function logError(err: any) {
  console.error(err);
}
